import React from "react";
import "./HomePage.scss";

import Directory from "../../components/directory/Directory";

function HomePage() {
  return (
    <div className="homepage">
      <Directory />
    </div>
  );
}

export default HomePage;
